/**
 * The brand's one bold element: a single tentacle curl. On the login screen it draws itself once
 * (styles.css `.tentacle-path`), and each sucker pops in as the stroke reaches it; elsewhere it's a
 * small static mark.
 */
const PATH =
  'M30 300 C 40 150, 130 60, 250 70 C 340 78, 380 150, 360 210 C 342 262, 280 280, 245 250 C 214 223, 226 180, 258 178 C 282 177, 292 198, 282 212';

/**
 * Suckers on the inner edge of the curl, touching the stroke, largest near the base: [cx, cy, r,
 * delay in s]. Worked out from PATH: the point at 12 %, 22 %, … of its length, pushed along the
 * inner normal by the stroke's half width plus the radius; the delay is when the draw-in (2.4 s,
 * the same easing, 0.2 s late) passes that point.
 */
const SUCKERS = [
  [64.7, 204.6, 6.5, 0.94],
  [106.3, 136.7, 6, 1.12],
  [170.9, 92.8, 5.5, 1.24],
  [249.5, 82.5, 5, 1.33],
  [320.6, 110, 4.5, 1.42],
  [352.9, 168.5, 4, 1.49],
  [339.8, 225.2, 3.5, 1.57],
  [297.5, 252.9, 3, 1.66],
];

export function TentacleArt({ className = '' }) {
  return (
    // The stroke's round caps and the base reach past the drawing's box, so the view box has room
    // on every side and `overflow: visible` keeps the base from being clipped at the panel's edge.
    <svg viewBox="0 0 400 320" className={className} overflow="visible" aria-hidden="true">
      <path
        d={PATH}
        fill="none"
        stroke="var(--accent)"
        strokeWidth="14"
        strokeLinecap="round"
        className="tentacle-path"
        style={{ '--len': 1000 }}
        pathLength="1000"
      />
      {SUCKERS.map(([cx, cy, r, delay]) => (
        <circle
          key={`${cx}-${cy}`}
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke="var(--accent)"
          strokeWidth="2.5"
          className="tentacle-sucker"
          style={{ '--delay': `${delay}s` }}
        />
      ))}
    </svg>
  );
}

export function TentacleMark({ className = 'size-6' }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <path
        d="M9 23c0-9 5-14 11-14 3.6 0 5.5 2.3 5.5 4.6 0 2.6-2 4.4-4.4 4.4-2 0-3.3-1.4-3.3-3 0-1.3.9-2.2 2-2.2"
        fill="none"
        stroke="var(--accent)"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
